<template>
	<div class="home">
		<img src="../../assets/mobile/homeBg.jpg" style="width: 100%;" />
		<div class="imgBoxArea">
			<div class="bigTitle wow bounceInLeft" data-wow-duration="1s" style="margin-top: 80px;">优质<label>内容</label></div>
			<div class="bigTitle wow bounceInLeft" data-wow-duration="1s" style="margin-left: 120px;"><label>创新</label>科技
			</div>
			<div class="bigTitle2 wow bounceInRight">重塑消费娱乐体验</div>
		</div>
		<div style="background: #000;padding-bottom: 50px;margin-left: -20px;">
			<el-carousel ref="carousel" :interval="4000" type="card" height="450px" :autoplay="true"
				:initial-index="initialIndex" @change="handleCarouselChange">
				<el-carousel-item :class="{'custom-active': activeIndex==0}" :style="getItemStyle(0)">
					<img src="../../assets/mobile/home_1.jpg" style="width: 100%;" @click="goto(2)"/>
				</el-carousel-item>
				<el-carousel-item :class="{'custom-active': activeIndex==1}" :style="getItemStyle(1)">
					<img src="../../assets/mobile/home_21.jpg" style="width: 100%;" @click="goto(1)"/>
				</el-carousel-item>
				<el-carousel-item :class="{'custom-active': activeIndex==2}" :style="getItemStyle(2)">
					<img src="../../assets/mobile/home_3.jpg" style="width: 100%;" @click="goto(3)"/>
				</el-carousel-item>
			</el-carousel>

		</div>
		<floating-ad  v-if="adVisible" :speed="speed" @flagClick="flagClick" @close="closeAd"></floating-ad>
	</div>
</template>

<script>
	import floatingAd from '../../compenents/advants.vue'
	import {
		WOW
	} from 'wowjs'
	export default {
		components:{
			floatingAd
		},
		name: 'Home',
		data() {
			return {
				activeIndex: 0,
				initialIndex: 0,
				activeTranslateX: 60,
				inactiveScale: 0.85,
				adVisible: true,
				speed: 1,
				// 调整点25: 添加可视区域尺寸跟踪
				viewportWidth: window.innerWidth,
				viewportHeight: window.innerHeight
			}
		},
		methods: {
			goto(type){
				this.$router.push({ path: '/mobile/business?demoType='+type});
			},
			flagClick(){
				this.$router.push({
					path: '/pc/cinema'
				});
			},
			// 调整点32: 添加关闭广告方法
			closeAd() {
				this.adVisible = false;
			},
			handleCarouselChange(currentIndex, prevIndex) {
				this.activeIndex = currentIndex;
			},
			updateInactiveScale(value) {
				this.inactiveScale = value;
			},
			getItemStyle(index) {
				if (index === this.activeIndex) {
					return {
						transform: `translateX(${this.activeTranslateX}px)`
					};
				}
				return {
					transform: `scale(${this.inactiveScale})`
				};
			},
			slideBanner() {
				//选中的轮播图
				var box = document.querySelector('.el-carousel__container');
				var startPoint = 0;
				var stopPoint = 0;
				//重置坐标
				var resetPoint = function() {
					startPoint = 0;
					stopPoint = 0;
				}
				//手指按下
				box.addEventListener("touchstart", function(e) {
					//手指点击位置的X坐标
					startPoint = e.changedTouches[0].pageX;
				});
				//手指滑动
				box.addEventListener("touchmove", function(e) {
					//手指滑动后终点位置X的坐标
					stopPoint = e.changedTouches[0].pageX;
				});
				//当手指抬起的时候，判断图片滚动离左右的距离
				let that = this
				box.addEventListener("touchend", function(e) {
					console.log("1：" + startPoint);
					console.log("2：" + stopPoint);
					if (stopPoint == 0 || startPoint - stopPoint == 0) {
						resetPoint();
						return;
					}
					if (startPoint - stopPoint > 0) {
						resetPoint();
						that.$refs.carousel.next();
						return;
					}
					if (startPoint - stopPoint < 0) {
						resetPoint();
						that.$refs.carousel.prev();
						return;
					}
				});
			},
		},
		created() {
			let isM = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if (!isM) {
				this.$router.push({
					path: '/pc/home'
				});
			}
		},
		mounted() {
			// 初始化CSS变量
			this.activeTranslateX = (window.innerWidth - 300) / 2 + 10
			document.documentElement.style.setProperty('--active-translate-x', `${this.activeTranslateX}px`);
			this.slideBanner()
			this.$nextTick(() => {
				this.activeIndex = this.$refs.carousel.activeIndex;
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		}
	}
</script>
<style lang="less" scoped>
	.imgBoxArea {
		position: absolute;
		top: 100px;
		left: 0;
		width: 100vw;
	}

	.bigTitle {
		font-size: 40px;
		letter-spacing: 0.02em;
		font-weight: 800;
		text-shadow: 0 4px 30px rgba(0, 0, 0, 0.45);

		label {
			color: #ff791f
		}
	}

	.bigTitle2 {
		font-size: 30px;
		font-weight: 1;
		margin-top: 60px;
	}

	.el-carousel__item {
		width: 300px !important;
		margin: 0 10px;
		/* 卡片间距 */
	}

	/* 当前激活卡片样式 */
	.el-carousel__item.is-active {
		transform: translateX(var(--active-translate-x, 0px)) !important;
		box-shadow: 0 8px 25px rgba(64, 158, 255, 0.3);
		z-index: 2;
	}

	/* 非激活卡片样式 */
	.el-carousel__item:not(.is-active) {
		transform: scale(0.95);
	}

	.el-carousel {
		margin-top: -150px;
	}

	.el-carousel__container {
		margin-left: -20px;
	}
</style>